import { action, observable } from "mobx";
import moment from "moment";

export interface Stat {
  id: number;
  name: string;
  date: string;
  cost: number;
  data_scanned_in_bytes: number;
}

export type InitialProps = {
  stats: Stat[];
  date: string;
};

let store: Store | undefined;

export function getStore() {
  if (!store) {
    throw new Error("Store not initialized");
  }
  return store;
}

export function createStore(props: InitialProps) {
  store = new Store(props);
}

export interface Filter {
  filter(stat: Stat): boolean;
  toString(): string;
}

export class TitleFilter implements Filter {
  id: number;
  name: string;

  constructor(id: number, name: string) {
    this.id = id;
    this.name = name;
  }

  filter(stat: Stat): boolean {
    return stat.id === this.id;
  }

  toString(): string {
    return `title:${this.name}`;
  }
}

export class DayFilter implements Filter {
  day: number;

  constructor(day: number) {
    this.day = day;
  }

  filter(stat: Stat): boolean {
    return moment(stat.date).get("date") === this.day;
  }

  toString(): string {
    return `day:${this.day}`;
  }
}

class Store {
  readonly stats: Stat[];
  readonly date: string;
  @observable accessor currentStats: Stat[] = [];
  @observable accessor filters: Filter[] = [];

  constructor(props: InitialProps) {
    this.stats = props.stats;
    this.date = props.date;
    this.updateCurrentStats();
  }

  @action addFilter(filter: Filter) {
    if (this.filters.some((f) => f.toString() === filter.toString())) {
      return;
    }
    this.filters.push(filter);
    this.updateCurrentStats();
  }

  @action removeFilter(index: number) {
    this.filters.splice(index, 1);
    this.updateCurrentStats();
  }

  @action updateCurrentStats() {
    this.currentStats = this.stats.filter((s) =>
      this.filters.every((f) => f.filter(s)),
    );
  }
}
